
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-journal/[slug]",
      function () {
        return require("private-next-pages/travel-journal/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-journal/[slug]"])
      });
    }
  